import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client
//
// Mutations must NOT auto-retry — they have side effects (connecting an
// exchange, opening a position, sending a trade), and retrying is what
// caused duplicate `exchange.test-credentials` runs and duplicate Mongo
// audit entries when an upstream 400/401 bubbled up. Failed mutations
// surface the error to the component; the user decides whether to
// retry.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

interface QueryProviderProps {
  children: React.ReactNode;
}

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};



